<template>
    <v-sheet>
        <resume-personal-information v-model="resume" @input="emit" />
        <resume-name v-model="resume" class="mt-40 mt-lg-60" @input="emit" />
        <resume-education v-model="resume" class="mt-40 mt-lg-60" @input="emit" />
        <resume-work-experience v-model="resume" class="mt-40 mt-lg-60" @input="emit" />
        <resume-hash-tags v-model="resume" v-bind="{ hashTags }" class="mt-40 mt-lg-60" @input="emit" />
        <resume-languages v-model="resume" class="mt-40 mt-lg-60" @input="emit" />
        <resume-office-skills v-model="resume" class="mt-40 mt-lg-60" @input="emit" />
        <resume-certifications v-model="resume" class="mt-40 mt-lg-60" @input="emit" />
        <resume-cover-letter v-model="resume" class="mt-40 mt-lg-60" @input="emit" />
        <div class="v-btn-group">
            <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="save()"><span class="grey-6--text">임시저장</span></v-btn>
            <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="save(MICEPEC_RECORDS.value)"><span>저장 후 다음으로</span></v-btn>
        </div>
        <!-- <v-row justify="center" class="ma-0 mt-40 mt-lg-60">
            <v-col cols="auto"> <v-btn large outlined color="#666" @click="save()">임시저장</v-btn> </v-col>
            <v-col cols="auto"> <v-btn large color="primary" @click="save(MICEPEC_RECORDS.value)">저장 후 다음으로</v-btn> </v-col>
        </v-row> -->
    </v-sheet>
</template>

<script>
import api from "@/api";
import { APPLICATION_STATES, APPLICATION_WRITIG_STEPS, initResume, USER_FILE_TYPES } from "@/assets/variables";

import ResumeName from "@/components/client/resume/resume-name.vue";
import ResumeHashTags from "@/components/client/resume/resume-hash-tags.vue";
import ResumeEducation from "@/components/client/resume/resume-education.vue";
import ResumeLanguages from "@/components/client/resume/resume-languages.vue";
import ResumeCoverLetter from "@/components/client/resume/resume-cover-letter.vue";
import ResumeOfficeSkills from "@/components/client/resume/resume-office-skills.vue";
import ResumeCertifications from "@/components/client/resume/resume-certifications.vue";
import ResumeWorkExperience from "@/components/client/resume/resume-work-experience.vue";
import ResumePersonalInformation from "@/components/client/resume/resume-personal-information.vue";

const state = APPLICATION_STATES.ON_WRITING.value;
const { RESUME, MICEPEC_RECORDS } = APPLICATION_WRITIG_STEPS;

export default {
    components: {
        ResumeName,
        ResumeHashTags,
        ResumeEducation,
        ResumeLanguages,
        ResumeCoverLetter,
        ResumeOfficeSkills,
        ResumeCertifications,
        ResumeWorkExperience,
        ResumePersonalInformation,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // form
        hashTags: { type: Array, default: () => [] },
        formResume: { type: Function, default: () => () => {} },
    },
    data: () => ({
        resume: initResume(),

        MICEPEC_RECORDS,
    }),
    computed: {
        isCreate() {
            return !this.value?._id;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.resume = { ...initResume(), ...(this.value?.resume || {}) };
        },
        emit() {
            this.$emit("input", { ...this.value, resume: { ...(this.value?.resume || {}), ...this.resume } });
        },
        async save(writingStep = RESUME.value) {
            let { _recruitment } = this.value;

            let { profile, ...resume } = this.resume || {};
            if (profile instanceof File) {
                profile = (await api.v1.me.files.post({ type: USER_FILE_TYPES.PROFILE.value }, profile))?.file;
            }
            resume._profile = profile?._id;

            let { post, put } = api.v1.recruitments.application;
            const { application } = await (this.isCreate ? post : put)({ _recruitment, resume, state, writingStep });
            application.resume = this.formResume(application.resume);
            this.$emit("input", application);

            alert("저장되었습니다");
        },
    },
};
</script>
